"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
exports.ContentMappingDetailContext = react_1.default.createContext({
    cmsId: null,
    contentMappingDraft: null,
    contentMappingOriginal: null,
    failedToParse: false,
    filteredContentItems: null,
    filterIsPending: false,
    mutateProxy: null,
    parseError: null,
    proxyResult: null,
    sampleContentItem: null,
    save: null,
    saveResult: null,
    sharedJsonViewProps: {
        groupArraysAfterLength: 4,
    },
    toggleFailedToParse: null,
    ui: null,
});
//# sourceMappingURL=context.js.map